import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { LegendExtendedContainer, LegendIconHigh, LegendIconLow, LegendItem, LegendCompactContainer } from './styles';
import { LegendBox } from '../../../LegendBox';
import { Text } from '../../../Text';
export var AreaLegend = function (_a) {
  var chanceValues = _a.chanceValues,
    chartAreasLegendText = _a.chartAreasLegendText,
    type = _a.type;
  var theme = useTheme();
  if (type === 'compact') {
    var highConfidenceGenericText = chartAreasLegendText.highConfidenceGenericText,
      lowConfidenceGenericText = chartAreasLegendText.lowConfidenceGenericText;
    return _jsxs(LegendCompactContainer, {
      children: [_jsxs(LegendItem, {
        children: [_jsx(LegendIconHigh, {}), _jsx(Text, {
          el: "span",
          styleName: "bodySmall",
          variant: "secondary",
          children: highConfidenceGenericText
        })]
      }), _jsxs(LegendItem, {
        children: [_jsx(LegendIconLow, {}), _jsx(Text, {
          el: "span",
          styleName: "bodySmall",
          variant: "secondary",
          children: lowConfidenceGenericText
        })]
      })]
    });
  }
  var lowestChance = chanceValues.lowestChance,
    lowChance = chanceValues.lowChance,
    highChance = chanceValues.highChance,
    highestChance = chanceValues.highestChance;
  var areasLegendExtendedHeading = chartAreasLegendText.areasLegendExtendedHeading,
    lowConfidenceYHighText = chartAreasLegendText.lowConfidenceYHighText,
    highConfidenceYHighText = chartAreasLegendText.highConfidenceYHighText,
    highConfidenceYLowText = chartAreasLegendText.highConfidenceYLowText,
    lowConfidenceYLowText = chartAreasLegendText.lowConfidenceYLowText;
  return _jsxs(LegendExtendedContainer, {
    children: [_jsx(LegendBox, {
      dotColor: theme.tokens.chart.primary.child2,
      title: lowConfidenceYHighText,
      subtitle: areasLegendExtendedHeading,
      value: lowestChance
    }), _jsx(LegendBox, {
      dotColor: theme.tokens.chart.primary.child1,
      title: highConfidenceYHighText,
      subtitle: areasLegendExtendedHeading,
      value: lowChance
    }), _jsx(LegendBox, {
      dotColor: theme.tokens.chart.primary.child1,
      title: highConfidenceYLowText,
      subtitle: areasLegendExtendedHeading,
      value: highChance
    }), _jsx(LegendBox, {
      dotColor: theme.tokens.chart.primary.child2,
      title: lowConfidenceYLowText,
      subtitle: areasLegendExtendedHeading,
      value: highestChance
    })]
  });
};